(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-button');
    const contents = document.querySelectorAll('.tab-content');
    const tabsContainer = document.querySelector('.tabs');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;

        tabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');
        contents.forEach((c) => c.classList.remove('active'));
        document.querySelector(`.tab-content[data-content="${target}"]`).classList.add('active');

        const tabRect = tab.getBoundingClientRect();
        const containerRect = tabsContainer.getBoundingClientRect();
        const offset = tabRect.left - containerRect.left - containerRect.width / 2 + tabRect.width / 2;
        tabsContainer.scrollBy({ left: offset, behavior: 'smooth' });

        // Reiniciar carrusel al cambiar de tab
        const activeContent = document.querySelector(`.tab-content[data-content="${target}"]`);
        const wrapper = activeContent.querySelector('.carousel-wrapper');
        if (wrapper && wrapper.carouselInstance) {
          wrapper.carouselInstance.reset();
        }
      });
    });

    // Inicializa carruseles
    document.querySelectorAll('.carousel-wrapper').forEach((wrapper) => {
      const track = wrapper.querySelector('.carousel-track');
      const cards = wrapper.querySelectorAll('.product-card');
      const prevBtn = wrapper.querySelector('.carousel-arrow.prev');
      const nextBtn = wrapper.querySelector('.carousel-arrow.next');
      const progressBar = wrapper.querySelector('.progress-bar');
      
      let currentIndex = 0;

      function getConfig() {
        if (window.innerWidth > 1024) {
          return { slidesPerView: 5, slidesPerMove: 5 };
        } else if (window.innerWidth > 749) {
          return { slidesPerView: 2, slidesPerMove: 2 };
        } else {
          return { slidesPerView: 1.35, slidesPerMove: 1 };
        }
      }

      function getMaxIndex() {
        const config = getConfig();
        const maxIndex = Math.ceil(cards.length - config.slidesPerView);
        return Math.max(0, maxIndex);
      }

      function updateCarousel() {
        const config = getConfig();
        const gap = 16;
        const cardWidth = cards[0].offsetWidth + gap;
        const translateX = currentIndex * cardWidth;
        
        track.style.transform = `translateX(-${translateX}px)`;

        // Actualizar barra de progreso
        const maxIndex = getMaxIndex();
        const progress = maxIndex > 0 ? ((currentIndex / maxIndex) * 100) : 100;
        progressBar.style.width = `${Math.min(100, Math.max(progress, (100 / (maxIndex + 1))))}%`;

        // Actualizar estado de botones
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex >= maxIndex;
      }

      function reset() {
        currentIndex = 0;
        updateCarousel();
      }

      prevBtn.addEventListener('click', () => {
        const config = getConfig();
        currentIndex = Math.max(0, currentIndex - config.slidesPerMove);
        updateCarousel();
      });

      nextBtn.addEventListener('click', () => {
        const config = getConfig();
        const maxIndex = getMaxIndex();
        currentIndex = Math.min(maxIndex, currentIndex + config.slidesPerMove);
        updateCarousel();
      });

      // Swipe móvil
      let startX = 0;
      let currentTranslate = 0;
      let isDragging = false;

      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        track.style.transition = 'none';
      });

      track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const currentX = e.touches[0].clientX;
        const diff = currentX - startX;
        const gap = 16;
        const cardWidth = cards[0].offsetWidth + gap;
        currentTranslate = currentIndex * cardWidth - diff;
        track.style.transform = `translateX(-${currentTranslate}px)`;
      });

      track.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = 'transform 0.4s ease';
        
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;
        const maxIndex = getMaxIndex();
        
        if (diff > 50) {
          currentIndex = Math.min(maxIndex, currentIndex + 1);
        } else if (diff < -50) {
          currentIndex = Math.max(0, currentIndex - 1);
        }
        
        updateCarousel();
      });

      window.addEventListener('resize', () => {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        updateCarousel();
      });

      // Guardar instancia para poder reiniciar desde los tabs
      wrapper.carouselInstance = { reset };

      updateCarousel();
    });

    // Color Swatches Functionality
    function initColorSwatches() {
      document.querySelectorAll('.color-swatches-container').forEach((container) => {
        const productId = container.dataset.productId;
        const productCard = container.closest('.product-card');
        const productImage = productCard.querySelector('.product-main-image');
        const productLink = productCard.querySelector('.product-card-link');
        const buyBtn = productCard.querySelector('.product-buy-btn');
        const labels = container.querySelectorAll('.color-swatch-label');
        
        // Guardar imagen y URL original
        const defaultImageSrc = productImage ? productImage.dataset.defaultSrc : null;
        const defaultProductUrl = productLink ? productLink.href : null;
        let selectedImageSrc = defaultImageSrc;
        let selectedProductUrl = defaultProductUrl;

        labels.forEach((label) => {
          const input = label.querySelector('.color-swatch-input');
          const imageUrl = label.dataset.imageUrl;
          const productUrl = label.dataset.productUrl;

          // Hover: cambiar imagen temporalmente
          label.addEventListener('mouseenter', () => {
            if (imageUrl && productImage) {
              productImage.srcset = '';
              productImage.src = imageUrl;
            }
          });

          // Mouse leave: volver a la imagen seleccionada
          label.addEventListener('mouseleave', () => {
            if (productImage && selectedImageSrc) {
              productImage.srcset = '';
              productImage.src = selectedImageSrc;
            }
          });

          // Click: seleccionar permanentemente
          label.addEventListener('click', () => {
            // Actualizar imagen seleccionada
            if (imageUrl) {
              selectedImageSrc = imageUrl;
              if (productImage) {
                productImage.srcset = '';
                productImage.src = imageUrl;
              }
            }

            // Actualizar URLs
            if (productUrl) {
              selectedProductUrl = productUrl;
              if (productLink) {
                productLink.href = productUrl;
              }
              if (buyBtn) {
                buyBtn.href = productUrl;
              }
            }

            // Marcar input como checked
            input.checked = true;
          });
        });

        // Inicializar con el primer swatch seleccionado
        const firstChecked = container.querySelector('.color-swatch-input:checked');
        if (firstChecked) {
          const firstLabel = firstChecked.closest('.color-swatch-label');
          const firstImageUrl = firstLabel.dataset.imageUrl;
          const firstProductUrl = firstLabel.dataset.productUrl;
          
          if (firstImageUrl) {
            selectedImageSrc = firstImageUrl;
          }
          if (firstProductUrl) {
            selectedProductUrl = firstProductUrl;
          }
        }
      });
    }

    initColorSwatches();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
